






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-archive',

})
export default class IArchive extends Vue {

  @Prop({type: [String], default: '#323232'}) protected color!: string

}

